export default __webpack_public_path__ + "static/media/image2-2.05ee9fc1.png";